import { useEffect } from 'react';

import { createSelector } from '@reduxjs/toolkit';
import { routes } from 'config/routes/protectedRoutes';
import { useAppSelector } from 'hooks/redux';
import { useDispatch } from 'react-redux';
import { selectSystem, setStartLocation } from 'store/system/systemSlice';
import { selectHasSession } from 'store/user/userSlice';
import { checkIsProtectedRoute } from 'utils/router';

const useStartLocationSelector = createSelector(
  [selectHasSession, selectSystem],
  (hasSession, system) => ({
    hasSession,
    startLocation: system.startLocation,
    wasLoggedOutManually: system.wasLoggedOutManually
  })
);

// This hook is used to store the location the user started from before they logged in.
// This is used to redirect the user to the previous location after they log in.
// This hook is used in the App component.
// This should NOT be used if the user is logged in or if the user logs out manually.

const useStartLocation = () => {
  const dispatch = useDispatch();
  const { hasSession, startLocation, wasLoggedOutManually } =
    useAppSelector(useStartLocationSelector);
  const { pathname, search } = window.location;
  const isProtectedRoute = checkIsProtectedRoute(pathname, routes);

  useEffect(() => {
    if (!startLocation && !hasSession && isProtectedRoute && !wasLoggedOutManually) {
      dispatch(setStartLocation({ pathname, search }));
    }
  }, [
    dispatch,
    startLocation,
    hasSession,
    isProtectedRoute,
    pathname,
    search,
    wasLoggedOutManually
  ]);
};

export default useStartLocation;
